import { showNativeNotification } from '@autobid/ui/utils/showNativeNotification'

export function usePushNotification() {
  const push = usePush()

  const sendPushNotification = (notification: string, tag?: string) => {
    if (!notification.length) {
      return
    }

    if (document.hasFocus()) {
      push.info(notification)
      return
    }
    showNativeNotification('Autobid', { body: notification, tag })
  }

  return { sendPushNotification }
}
